import { GlobalConstants } from "../../utils/app-constants";

export class PagedApiResult<T> {

    public pagination : PageData;
    public results : T[] = [];

    constructor(pageData? : PageData) {
        this.pagination = pageData ? pageData : new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);        
    }

}

export class PageData {

    public take    : number = 0;
    public skip    : number = 0;
    public current : number = 0;    
    public isEnd   : boolean = true;

    public pageCount : number = 1;
    public reusePaging: boolean = false;
    public totalItems?: number;
    public totalPages?: number;

    constructor(pageSize?: number) {
        this.take = (pageSize) ? pageSize : 25;
    }

    public canSkip = () => {
        return !!this.totalItems;
    }

    public isNextDisabled = () => {
        return this.isEnd;
    }

    public isPrevDisabled = () => {
        return (this.skip === 0);
    }

    public goStart = () => {
        this.skip = 0;
        this.pageCount = 1;
    }

    public goBack = () => {
        this.skip = this.skip - (this.current + this.take);
        this.pageCount--;
    }

    public goForward = () => {
        this.skip = (this.skip + this.take);
        this.pageCount++;
    }

    public goEnd = () => {

        if (this.totalPages) {
            this.skip = (this.totalPages - 1) * this.take;
            this.pageCount = this.totalPages;
        }
    }
}